import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { requestResendOTP, requestVerifyOTP } from '../../../api/login';
// reducer

import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { authUser } from '../../../redux/modules/auth';
import SMSCountDown from '../SMSCountDown';

const OTPModal = ({
  showOtpModal,
  onHide,
  userCred,
  setShowOtpModal,
  isOtpVia,
  holder,
  setHolder,
}) => {
  let defaultValue = 0;
  if (isOtpVia === 'sms') {
    defaultValue = 300;
  } else {
    defaultValue = 120;
  }
  const dispatch = useDispatch();
  const { isAuthed } = useSelector(({ auth }) => auth);
  const [form, setForm] = useState({ otp: '' });
  const [otpVia, setOtpVia] = useState('');

  const [counter, setCounter] = useState(defaultValue);
  const [counterSms, setCounterSMS] = useState(300);

  useEffect(() => {
    if (isOtpVia === 'email') {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [showOtpModal ? counter : null]);

  function getMinAndSec(seconds) {
    const min = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return (
      min.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0')
    );
  }

  const countDown = getMinAndSec(counter);

  const handleChange = (e) => {
    setForm({ ...form, otp: e });
    //setForm({ ...form, otp: e.target.value });
  };

  const verifyOtp = async () => {
    try {
      const newForm = {
        username: userCred.username,
        password: userCred.password,
        temp_token: userCred.temp_token,
        otp: form.otp,
      };

      Swal.fire({
        title: 'Loading...',
        html: 'Please wait...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const res = await requestVerifyOTP(newForm);

      const { code, result } = res.data.response;

      if (code === '00000') {
        let tmpUser = result.user;
        let roles = result.user.roles.map(({ role }) => role);
        Swal.close();
        const isAdmin = result.user.roles.find(({ slug }) => slug === 'admin');

        if (isAdmin) roles.push('aaf1');
        //if (!result.permissions.length) roles.push("aaf1");

        dispatch(
          authUser({
            accessToken: result.access_token,
            user: { ...tmpUser, roles },
            permissions: [...result.permissions],
          }),
        );
        // if (isAuthed) {
        window.location.href = '/dashboard';
        // }
      } else {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: result,
        });
      }
    } catch (error) {
      toast.error('Invalid OTP.');
    }

    setForm({ ...form, otp: '' });
  };

  const resendOtp = async () => {
    const tload = toast.loading('Please wait ...');

    try {
      const newForm = {
        username: userCred.username,
        password: userCred.password,
        otp: form.otp,
      };
      const res = await requestResendOTP(newForm);

      const { code, result, otp_via } = res.data.response;

      setOtpVia(otp_via);

      toast.dismiss(tload);

      if (code === '00000' || code === '200') {
        const { isConfirmed } = await Swal.fire({
          icon: 'success',
          title: 'One Time Password (OTP).',
          text: `Your code was successfully sent to you via ${
            isOtpVia === 'email' ? 'email' : 'sms'
          }`,
        });

        if (isConfirmed) {
          setHolder(true);
          if (isOtpVia === 'email') {
            setCounter(120);
          } else {
            setCounter(300);
            setCounterSMS(300);
          }
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: result,
        });
      }
      setHolder(true);
    } catch (error) {
      toast.dismiss(tload);
      toast.error('Your code was not sent to you via email.');
    }
  };

  const onHideModal = () => {
    setForm({ ...form, otp: '' });
    setHolder(false);
    setShowOtpModal(false);
  };

  return (
    <>
      <Modal
        show={showOtpModal}
        onHide={onHide}
        size="xs"
        keyboard={false}
        backdrop="static"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        className="mt-4"
      >
        <Modal.Body>
          <br />
          <h4 className="text-center p-3">
            Please enter the one time password (OTP) to verify your account
          </h4>
          <br />
          <h6 className="text-center text-danger">
            Your code was sent to you via {isOtpVia === 'sms' ? 'sms' : 'email'}
          </h6>
          <br />
          <br />
          <div class="container">
            <div className="form-group d-flex justify-content-center">
              <OtpInput
                value={form.otp}
                name="otp"
                onChange={handleChange}
                numInputs={6}
                renderSeparator={<span>&nbsp;&nbsp; </span>}
                renderInput={(props) => <input {...props} />}
                inputStyle="form-control w-25"
              />
            </div>
            <br />
            <div className="form-group d-flex justify-content-center">
              <Button
                className="btn btn-primary w-50 text-white"
                onClick={verifyOtp}
                disabled={!form.otp}
              >
                Verify
              </Button>
            </div>
          </div>
          <br />
          <br />
        </Modal.Body>
        <Modal.Footer>
          {counter === 0 ? (
            <>
              <p class="text-left">
                Didn't receive code?
                <Button
                  onClick={resendOtp}
                  variant="link"
                  style={{ color: 'blue', padding: '3px', marginTop: '-5px' }}
                >
                  Resend
                </Button>
              </p>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              &nbsp; &nbsp; &nbsp;
              <Button variant="info" className="text-white" onClick={onHide}>
                Close
              </Button>
            </>
          ) : (
            <>
              {isOtpVia === 'email' ? (
                <>
                  <p class="text-center">
                    Please wait for the remaining time to resend an OTP :&nbsp;
                    <b> {countDown}</b>
                  </p>
                  &nbsp; &nbsp; &nbsp;
                  <Button
                    variant="info"
                    className="text-white"
                    onClick={onHideModal}
                  >
                    Closes
                  </Button>
                  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                  &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;
                </>
              ) : (
                <>
                  <SMSCountDown
                    holder={holder}
                    setHolder={setHolder}
                    showOtpModal={showOtpModal}
                    resendOtp={resendOtp}
                    onHide={onHide}
                    counterSms={counterSms}
                    setCounterSMS={setCounterSMS}
                  />
                </>
              )}
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OTPModal;

//https://www.npmjs.com/package/react-otp-input
